import React from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab } from '@cred/react-tabs'
import { tabClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import Dashboard from '../dashboard/App'
import { CashOutError, ValidationsError } from '../error-pages'
import styles from './styles.module.scss'

const tabsIndexes = {
  'top-rates': 0,
  'all-rates': 1,
}
const TabsForm = props => {
  const {
    activeTab,
    onGetStarted,
    error,
    loading,
    bestProducts,
    allProducts,
    isFullTable,
    analyticsContexts,
    paginationProps,
    theme,
    isCashOutError,
    isValidationsError,
    isPurchase,
    trackSnowplowEvent,
  } = props

  const tabTitleList = [
    `Top rates (${error ? 0 : bestProducts.length})`,
    `All rates (${error ? 0 : allProducts.length})`,
  ]

  const onTabClick = index => {
    trackSnowplowEvent(
      tabClick,
      {
        text: tabTitleList[index],
      },
      [...analyticsContexts],
    )
  }

  return (
    <div className={styles[`${theme}Container`]}>
      {isCashOutError && <CashOutError />}
      {isValidationsError && !isCashOutError && <ValidationsError isPurchase={isPurchase} />}
      {!isCashOutError && !isValidationsError && (
        <Tabs
          activeTab={tabsIndexes[activeTab]}
          type="flat"
          onTabClick={onTabClick}
          branding={{
            tabHeader: 'tab-header',
            tabContent: 'tab-content',
            tabItem: loading ? 'tabs-hidden' : 'tab-item',
            tabItemWrapper: 'tab-item-wrapper',
            tabActive: 'tab-active',
          }}
        >
          <Tab title={<span>{tabTitleList[0]}</span>}>
            <Dashboard
              onGetStarted={onGetStarted}
              error={error}
              loading={loading}
              products={bestProducts}
              isFullTable={isFullTable}
              analyticsContexts={analyticsContexts}
              paginationProps={paginationProps}
            />
          </Tab>
          <Tab title={<span>{tabTitleList[1]}</span>}>
            <Dashboard
              onGetStarted={onGetStarted}
              error={error}
              loading={loading}
              products={allProducts}
              isFullTable={isFullTable}
              analyticsContexts={analyticsContexts}
              paginationProps={paginationProps}
            />
          </Tab>
        </Tabs>
      )}
    </div>
  )
}
TabsForm.propTypes = {
  isFullTable: PropTypes.bool.isRequired,
  onGetStarted: PropTypes.func.isRequired,
  analyticsContexts: PropTypes.array,
  error: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  bestProducts: PropTypes.array.isRequired,
  activeTab: PropTypes.string.isRequired,
  allProducts: PropTypes.array.isRequired,
  paginationProps: PropTypes.object.isRequired,
  theme: PropTypes.string.isRequired,
  isCashOutError: PropTypes.bool.isRequired,
  isValidationsError: PropTypes.bool.isRequired,
  isPurchase: PropTypes.bool.isRequired,
  trackSnowplowEvent: PropTypes.func.isRequired,
}

export default withSnowplowContexts(TabsForm)
